var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedPlayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_841_352)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.1564,
    cy: 24.1115,
    r: 23.3366,
    fill: "url(#paint0_linear_841_352)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0664 22.3794C35.3997 23.1492 35.3997 25.0737 34.0664 25.8435L21.6348 33.0209C20.3015 33.7907 18.6348 32.8285 18.6348 31.2889L18.6348 16.9341C18.6348 15.3945 20.3015 14.4322 21.6348 15.202L34.0664 22.3794Z",
    fill: "#FF020A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_841_352",
    x: -399.18,
    y: -399.225,
    width: 846.673,
    height: 846.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 200
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_841_352"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_841_352",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_841_352",
    x1: 24.1564,
    y1: 0.774902,
    x2: 24.1564,
    y2: 47.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPlayArrow);
export default __webpack_public_path__ + "static/media/red-play-arrow.da0a44a691781585b87547f058e6e4fb.svg";
export { ForwardRef as ReactComponent };